// extracted by css-extract-rspack-plugin
export default {"loadingState":"loadingState-A4DYjv"};